
import { defineComponent, computed, ref, watchEffect } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { Actions } from "@/store/enums/StoreEnums";
import { useToast } from "vue-toastification";

interface ReviewNote {
  irbApplicationId: string;
  type: string;
  note: string;
}

export default defineComponent({
  name: "review-note-modal",
  components: {},
  props: {
    type: String,
  },
  setup(props) {
    const store = useStore();
    const route = useRoute();
    const toast = useToast();
    const currentIrbReviewNoteType = computed(() => {
      return store.getters.currentIrbReviewNotesType;
    });

    const allowCreateNote = computed(() => {
      return store.getters.currentIrbReviewNotesType?.data?.options != undefined? store.getters.currentIrbReviewNotesType?.data?.options["create_notes"] != undefined: false;
    });

    const allowCreateNotetype = computed(() => {
      return store.getters.currentIrbReviewNotesType?.data?.options != undefined?store.getters.currentIrbReviewNotesType?.data?.options["create_notes"] : "";
    });

    const formRef = ref<null | HTMLFormElement>(null);
    const loading = ref<boolean>(false);
    const propType = ref(props.type);
    const formData = ref<ReviewNote>({
      irbApplicationId: "",
      type: "",
      note: "",
    });

    const currentIrbReviewNote = computed(() => {
      return store.getters.currentReviewNoteEdit;
    });

    watchEffect(() => {
      const data = store.getters.currentReviewNoteEdit;
      if (data == null) {
        formData.value.note = "";
        return;
      }
      formData.value.note = data.note;
    });

    const submit = () => {
      loading.value = true; //loading.value = false;
      const jsonRequest = {
        irbApplicationId: route.params.id,
        type: props.type,
        note: formData.value.note,
      };
      store
        .dispatch(Actions.POST_IRB_REVIEW_NOTE, JSON.stringify(jsonRequest))
        .then(() => {
          loading.value = false;
          toast.success("Information Saved", {
                timeout: 2000
              });
              


            store.dispatch(Actions.GET_IRB_REVIEW_NOTES_TYPE, {
              params: {
                id: route.params.id,
                type: props.type,
              },
            });
          
        })
        .catch(() => {
          loading.value = false;
          toast.error(store.getters.getIrbError, {
                timeout: 2000
              });

        });
    };

    return {
      currentIrbReviewNote,
      submit,
      loading,
      formRef,
      formData,
      currentIrbReviewNoteType,
      allowCreateNote,
      allowCreateNotetype,
      propType,
    };
  },
});
